// ----------------------------------------------------------------------
// <copyright file="Izenda.ColorDialog.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');

  var Hue = require('./Izenda.Hue');
  var Saturation = require('./Izenda.Saturation');
  var ColorPreviews = require('./Izenda.ColorPreviews');
  var ColorFields = require('./Izenda.ColorFields');
  var ColorDialogUtils = require('./Izenda.ColorDialogUtils');

  const { assign } = require('lodash/fp');

  var ColorDialog = React.createClass({
    getDefaultProps: function() {
      return {
        color: {
          h: 0,
          s: 0,
          l: 1,
          a: 0
        }
      };
    },

    getInitialState: function() {
      var props = this.props;
      return assign(ColorDialogUtils.toState(props.color, 0), {
        visible: props.display,
        currentColor: props.color
      });
    },

    handleChange: function(data) {
      var isValidColor = ColorDialogUtils.simpleCheckForValidColor(data);

      if (isValidColor) {
        var colors = ColorDialogUtils.toState(data, data.h || this.state.oldHue);
        this.setState(colors);
        this.props.onChangeComplete && this.debounce(this.props.onChangeComplete, colors);
        this.props.onChange && this.props.onChange(colors);
      }
    },

    handleAccept: function() {
      this.props.onAccept && this.props.onAccept(this.state.hex);
    },

    componentWillReceiveProps: function(nextProps) {
      this.setState(
        assign(ColorDialogUtils.toState(nextProps.color, this.state.oldHue), {
          visible: nextProps.display
        })
      );
    },

    render: function() {
      var localization = this.props.localization;

      return (
        <div className="izenda-ColorDialog">
          <div className="izenda-ColorDialog-header">{localization.getText('COLOR_DIALOG_LABEL_TITLE')}</div>

          <div className="izenda-ColorDialog-content">
            <div className="izenda-ColorDialog-saturation izenda-Disable-move">
              <Saturation hsl={this.state.hsl} hsv={this.state.hsv} onChange={this.handleChange} />
            </div>
            <div className="izenda-ColorDialog-hue izenda-Disable-move">
              <Hue direction="vertical" hsl={this.state.hsl} onChange={this.handleChange} />
            </div>
            <div className="izenda-ColorDialog-controls">
              <div className="u_flex">
                <div className="izenda-ColorDialog-previews">
                  <ColorPreviews rgb={this.state.rgb} currentColor={this.state.currentColor} />
                </div>
                <div className="izenda-ColorDialog-actions">
                  <div className="izenda-ColorDialog-button" onClick={this.handleAccept}>
                    {localization.getText('COMMON_LABEL_OK')}
                  </div>
                  <div className="izenda-ColorDialog-button" onClick={this.props.onCancel}>
                    {localization.getText('COMMON_LABEL_CANCEL')}
                  </div>
                  <ColorFields
                    rgb={this.state.rgb}
                    hsv={this.state.hsv}
                    hex={this.state.hex}
                    onChange={this.handleChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  });

  module.exports = connect()(ColorDialog);
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/ColorDialog/Izenda.ColorDialog.jsx